import { ANALYTICS_SEGMENT, ANALYTICS_SESSION_ID_STORAGE_KEY } from 'Constants/analytics';
import segmentClient from 'Utilities/analytics/segmentClient';
import { getAppVersion } from 'Utilities/dataHelpers';
import { store } from 'Utilities/store';
let _analyticsClient;
const getSessionId = () => {
  let sessionId = sessionStorage.getItem(ANALYTICS_SESSION_ID_STORAGE_KEY);
  if (sessionId) {
    return sessionId;
  }
  sessionId = crypto.randomUUID();
  sessionStorage.setItem(ANALYTICS_SESSION_ID_STORAGE_KEY, sessionId);
  return sessionId;
};
export const initialize = (config, userRegion) => {
  if (!config || config.driver === '' || config.driver === 'none' || !userRegion) {
    return;
  }
  const analyticsType = config.driver;
  if (analyticsType === ANALYTICS_SEGMENT) {
    _analyticsClient = segmentClient;
    const writeKey = config.configuration?.region?.[userRegion]?.writeKey;
    if (writeKey) {
      _analyticsClient.initialize(writeKey);
    }
  }
};
export const track = (event, properties) => {
  const {
    auth: {
      user
    },
    config: {
      region
    }
  } = store.getState();
  const sessionId = getSessionId();
  const {
    build,
    version
  } = getAppVersion();
  const userRegion = region ?? '';
  const userCountry = user.country;
  const userLanguage = user.uiLanguage;
  _analyticsClient?.track(event, {
    sessionId,
    build,
    version,
    userRegion,
    userCountry,
    userLanguage,
    ...properties
  });
};
export const identify = userId => {
  _analyticsClient?.identify(userId);
};